import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  fireCustomDimension,
  getGa4PageViewSet,
  collectEventfireGa4,
} from 'utils/common';
import ErrorBoundary from 'components/ErrorBoundary';
import Cookie from 'utils/cookies';
// import Cookie from 'utils/cookies';
import _get from 'lodash.get';
import {
  //getUserTimesPointByPRC,
  getPrcCookieValue,
  getUserTimesPaidPoints,
  fetchUserSubscriptionStatusFromApi,
  getGeoCountry,
  setPayloadInfo,
  getEncTicket,
} from 'utils/primeUtil';
import { primePaymentflowStartEmitter } from 'components/EventEmitters';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import {
  PRC_FOR_NEVER_REGISTER,
  PRC_FOR_FT_EXPIRED,
  PRC_FOR_FTU,
  PRC_FOR_SUBSCRIBED,
  PRC_FOR_SUBSCRIPTION_EXPIRED,
  PRC_FOR_SUBSCRIPTION_CANCELLED,
  PRIMESCREEN_STORAGE_NAME,
} from 'constants/index';
import {
  redirectToNewPlanpage,
  newPlanpageMetaData,
  sendDataToGAWithGRX,
} from 'components/ToiSubscription/utils/redirectionToPlanPage';
// eslint-disable-next-line no-unused-vars, import/extensions
import grxlocalStorage from '../../../components_library/utils/grxUtil/grxLocalStorageUtil.js';

const LOGIN_PAGE_REFRESH = 'login_page_refresh';

function LoadWidget(ComponentName) {
  return React.lazy(() => import(`./${ComponentName}/index`));
}

class PrimeScreen extends React.Component {
  constructor(props) {
    super(props);
    this._const = {
      HRS_IN_DAY: 24,
      MINS_IN_HR: 60,
      SEC_IN_MIN: 60,
      MILLISEC_IN_SEC: 1000,
      SHOW_BLOCKER_TO_FTAU_DAYS_BEFORE: 7,
      TOPBAND_CTA_EXPIRY_HOURS: 72,
      TOPBAND_DISMISS_EXPIRY_HOURS: 72,
      TOAST_TIP_EXPIRY_HOURS: 24,
      prcStates: [
        PRC_FOR_FT_EXPIRED,
        PRC_FOR_FTU,
        PRC_FOR_SUBSCRIPTION_EXPIRED,
        PRC_FOR_SUBSCRIPTION_CANCELLED,
      ],
    };
    this.timesPoints = false;
    this.state = {
      LoadedComponent: false,
      hasMounted: false,
      mounted: {
        [props.componentName]: false,
      },
      commonNudgesTranslations: {},
    };
  }

  loginEventRefresh = () => {
    this.TopBandResetSessionStorage = true;
    this.removeStorage(PRIMESCREEN_STORAGE_NAME.TopBand.SESSIONNAME, true);
  };

  fireGA4 = obj => {
    const gaPageViewObj = getGa4PageViewSet() || {};
    const collatedGadata = {
      ...gaPageViewObj,
      event: 'select_item',
    };
    return collectEventfireGa4(collatedGadata, {
      item_name:
        window.location.href.indexOf('.cms') > -1
          ? document.title
          : window.location.href,
      item_id: this.props.msid || '',
      item_brand: 'product_interventions',
      item_category: 'Nudges',
      item_category2: window.location.href.indexOf('liveblog')
        ? 'liveblog'
        : 'homepage',
      item_category3: obj?.item_category3 ? obj?.item_category3 : 'N/A',
      item_category4: obj?.item_category4 ? obj?.item_category4 : 'N/A',
      location_id: obj?.location_id ? obj?.location_id : 'N/A',
    });
  };

  componentDidMount() {
    const { componentName } = this.props;
    this.setState({ hasMounted: true });
    // Load Component.
    if (!this.state.LoadedComponent) {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({
        LoadedComponent: LoadWidget(componentName),
      });
    }
    window.addEventListener(
      LOGIN_PAGE_REFRESH,
      this.loginEventRefresh.bind(this),
    );

    this.checkMounting();
    this.geoCountry = getGeoCountry();
    // /this.getCommonNudgesTranslations();
  }

  // getCommonNudgesTranslations = () => {
  // if (
  //   //typeof this.state.commonNudgesTranslations === 'undefined' ||
  //   Object.keys(this.state.commonNudgesTranslations).length === 0
  // ) {
  //   let url = this.props.isWapView
  //     ? TOI_SUBS_COMMON_NUDGES_TRANSLATIONS_MWEB
  //     : TOI_SUBS_COMMON_NUDGES_TRANSLATIONS_WEB;
  //   url += `&cc=${this.geoCountry}`;
  //   makeRequest
  //     .get(url, {}, 'skipfeedengine')
  //     .then(data => {
  //       if (data.status === 200 && data.data) {
  //         window.videoshowNudgeTranslations = data.data.videoshowNudge;
  //         this.setState({ commonNudgesTranslations: data.data });
  //       }
  //     })
  //     .catch(err => console.log(err));
  // }
  // };

  checkMounting = () => {
    const prc = this.getPrcValue();
    const { componentName } = this.props;
    // do not run if localstorage is not allowing
    let checkFromLocalStorage;
    if (componentName === 'TopBand') {
      // check from session
      const topBandSessionStorage = this.getStorage(
        PRIMESCREEN_STORAGE_NAME[componentName].SESSIONNAME,
        true,
      );

      // check from dismiss button
      const checkFromDismiss = this.checkComponentExpiryTime(
        PRIMESCREEN_STORAGE_NAME[componentName].DISMISS,
      );

      // check from expiry
      const checkFromCTA = this.checkComponentExpiryTime(
        PRIMESCREEN_STORAGE_NAME[componentName].CTACLICK,
      );

      checkFromLocalStorage =
        !topBandSessionStorage && checkFromCTA && checkFromDismiss;
    } else {
      checkFromLocalStorage = this.checkComponentExpiryTime(
        PRIMESCREEN_STORAGE_NAME[componentName],
      );
    }

    if (!checkFromLocalStorage) {
      return;
    }
    if (prc === PRC_FOR_NEVER_REGISTER) {
      this.setState({
        mounted: {
          [componentName]: true,
        },
      });
      return;
    }

    // do not call again and again.
    if (!this.end_date_timestamp && prc !== PRC_FOR_NEVER_REGISTER) {
      this.getEndDate(primeEndDate => {
        this.setState({
          mounted: {
            [componentName]: true,
          },
          end_date: primeEndDate,
        });
      });
    }
  };

  getEndDate = cb => {
    fetchUserSubscriptionStatusFromApi(this.props.userPrcData).then(data => {
      const primeEndDate = data.data.endDate || false;
      this.end_date_timestamp = data.data.timestamp || false;
      cb(primeEndDate);
    });
  };
  updateCommonTranslationState = () => {
    this.setState({
      commonNudgesTranslations: this.props.translationData,
    });
  };
  componentDidUpdate(prevProps) {
    if (
      (prevProps.userData &&
        (prevProps.userData.prcValue !== this.props.userData.prcValue ||
          prevProps.userPrcData !== this.props.userPrcData)) ||
      prevProps.msid !== this.props.msid
    ) {
      this.checkMounting();
    }
    if (
      (typeof this.state.commonNudgesTranslations === 'undefined' ||
        Object.keys(this.state.commonNudgesTranslations).length === 0) &&
      this.props.translationData &&
      this.props.translationData.currencyCode
    ) {
      this.updateCommonTranslationState();
    }
  }

  getStorage = (storageName, isSessionStorage) => {
    const storageObj = isSessionStorage ? sessionStorage : localStorage;
    return storageObj.getItem(storageName);
  };

  removeStorage = (storageName, isSessionStorage) => {
    const storageObj = isSessionStorage ? sessionStorage : localStorage;
    return storageObj.removeItem(storageName);
  };

  checkComponentExpiryTime = storageName => {
    if (!storageName) {
      // allow if storage not found
      return true;
    }
    try {
      const currentTime = new Date().getTime();
      const expiryTime = this.getStorage(storageName);
      return !expiryTime || (expiryTime && currentTime > expiryTime);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    }
    return true;
  };

  showBlockerToFTU = prc => {
    const daysLeft = this.getActiveDaysLeft();
    return (
      prc === PRC_FOR_FTU &&
      daysLeft > 0 &&
      daysLeft <= this._const.SHOW_BLOCKER_TO_FTAU_DAYS_BEFORE
    );
  };

  getActiveDaysLeft = () => {
    const dateDiff = this.end_date_timestamp - new Date().getTime();
    const daysInMilliSeconds =
      this._const.HRS_IN_DAY *
      this._const.MINS_IN_HR *
      this._const.SEC_IN_MIN *
      this._const.MILLISEC_IN_SEC;
    return dateDiff / daysInMilliSeconds;
  };

  redirectionToPlan = ({ item_category3 }) => {
    const prc = this.getPrcValue();

    if (
      this.props.userData.isLoggedIn ||
      Cookie.get('ssoid') ||
      Cookie.get('ssoId')
    ) {
      getEncTicket(this.props.isWapView).then(data => {
        window.location.href = redirectToNewPlanpage(
          newPlanpageMetaData(
            {
              ...this.props.translationData?.unifiedNodes[`prc${prc}`],
              acqSubSource: item_category3 || 'homepage_Inline_Nudge',
            },
            data,
          ),
        );
      });
    } else {
      window.location.href = redirectToNewPlanpage(
        newPlanpageMetaData({
          ...this.props.translationData?.unifiedNodes?.notLoggedIn,
          acqSubSource: 'homepage_Inline_Nudge',
        }),
      );
    }
  };

  replaceTokens = element => {
    const propsToPass = {
      date: this.state.end_date,
      timesPoints: this.timesPoints,
    };

    if (typeof element === 'function') {
      return element({ ...propsToPass });
    }

    return element;
  };

  fireGA = (gaAction, gaLabel, nonInteraction) => {
    const data = {};
    if (gaAction) {
      data.gaAction = gaAction;
      data.gaLabel = gaLabel || '';
      data.noSpaceReplace = true;
      data.nonInteraction = nonInteraction;
      sendGaThroughProps({ data });
    }
  };

  learnmoreClickHandler = (e, data) => {
    primePaymentflowStartEmitter({
      formType: 'learnMoreScreen',
      utmsFinal: data.utms,
    });
    this.fireGA(data.ga_action, data.ga_label);
  };

  setInLocalStorage = (storageName, value, isSessionStorage) => {
    try {
      const storageObj = isSessionStorage ? sessionStorage : localStorage;
      storageObj.setItem(storageName, value);
      return true;
    } catch (e) {
      return false;
    }
  };

  /* This method is to handle the flow of TOI subscription
    it uses the below event which has screenType param which
   controls which screen is to be shown next
  */
  toiPlusSubscriptionHandler = (e, screenType) => {
    e.preventDefault();
    if (screenType === 'planScreen') {
      this.redirectionToPlan();
    }
  };

  ctaClickHandler = (e, data) => {
    const { userData } = this.props;
    e.preventDefault();
    const prc = this.getPrcValue();
    if (data && data.type === 'newPlanPage') {
      const grxParams = [
        'paywall',
        {
          client_source: 'cdp',
          event_nature: 'click',
          event_category: 'subscription',
          cta_text: data.cta_text || 'Subscribe',
          // event_section: 'homepage_prime_slider',
          // event_sub_section: '',
          // landing_l1: 'plan_page',
          // landing_l2: '',
          // landing_l3: '',
          // landing_page_template: 'home',
          // landing_url: redirectToNewPlanpage(
          //   newPlanpageMetaData(this.props.translationData?.unifiedNodes?.notLoggedIn),
          // ),
          position: 4,
          unique_subscription_id: `${Cookie.get(
            '_grx',
          )}_${new Date().getTime()}`,
        },
      ];
      let cdpInfo = {};
      if (
        typeof window.grx !== 'undefined' &&
        typeof window?.grx_module?.hitPaywallEventReact === 'function'
      ) {
        window.grx_module.hitPaywallEventReact(...grxParams);
        cdpInfo = window.grx_module.getCdpInfo() || {};
      } else {
        window.Times.setGRXDataInLocalStorage('GRX_QUEUE_EVENT', {
          eventName: grxParams[0],
          payload: grxParams[1],
        });
      }
      const cdpParamsObj = grxParams[1] || {};
      const dataToBepassed = {
        accessiblefeatures: this.props.userPrcData?.accessibleFeatures,
        msid: this.props.msid,
        source: this.props.userPrcData?.source,
        accessType: this.props.userPrcData?.accessType,
        analytics_cdp: {
          eventName: grxParams[0],
          ...cdpParamsObj,
          ...cdpInfo,
        },
        objUserData: {
          email:
            typeof userData?.getEmail !== 'undefined'
              ? userData.getEmail()
              : '',
          fname:
            typeof userData?.getFirstName !== 'undefined'
              ? userData.getFirstName()
              : '',
        },
        ga4Items: this.fireGA4({
          item_category4: e.target.innerText || '',
          item_category3: data.item_category3 || 'homepage_Inline_Nudge',
        }),
      };

      sendDataToGAWithGRX(dataToBepassed).then(() =>
        this.redirectionToPlan({ item_category3: data.item_category3 }),
      );
    } else {
      switch (prc) {
        case PRC_FOR_NEVER_REGISTER:
          primePaymentflowStartEmitter({
            //formType: 'verifyMobileScreen',
            formType: 'paymentScreen',
            stop_redirection_for_subscribed: true,
            utmsFinal: data.utms,
          });
          this.fireGA(data.ga_action, data.ga_label);
          break;
        // rest of 4 cases, don't add break.
        case PRC_FOR_FTU:
        case PRC_FOR_FT_EXPIRED:
        case PRC_FOR_SUBSCRIPTION_EXPIRED:
        case PRC_FOR_SUBSCRIPTION_CANCELLED:
          primePaymentflowStartEmitter({
            formType: 'paymentScreen',
            utmsFinal: data.utms,
          });
          this.fireGA(data.ga_action, data.ga_label);
          break;
        default:
          break;
      }
    }
  };

  getExpiryHoursAndCloseWidget = (storageName, hours, isSessionStorage) => {
    const MILLISEC_IN_HRS =
      this._const.MINS_IN_HR *
      this._const.SEC_IN_MIN *
      this._const.MILLISEC_IN_SEC;
    const expiryTime = new Date().getTime() + hours * MILLISEC_IN_HRS;
    const { componentName } = this.props;
    this.setInLocalStorage(storageName, expiryTime, isSessionStorage);
    this.unmountWidget(componentName);
  };

  unmountWidget = componentName => {
    this.setState({
      mounted: {
        [componentName]: false,
      },
    });
  };

  clickHandler = (e, data, setCurrencyCodeDimension = false) => {
    if (data?.ga_action) {
      setPayloadInfo(data.ga_action, 'NON_STORY');
    }
    if (setCurrencyCodeDimension) {
      fireCustomDimension(
        this.state.commonNudgesTranslations.currencyCode,
        'dimension38',
      );
    }
    if (data && data.nudgeType) {
      fireCustomDimension(data.nudgeType);
    }
    const { componentName } = this.props;
    switch (data.type) {
      case 'TopBandBtnInView': {
        // this will if prvent prime user auto refresh issue.
        if (!this.TopBandResetSessionStorage) {
          this.setInLocalStorage(
            PRIMESCREEN_STORAGE_NAME[componentName].SESSIONNAME,
            true,
            true,
          );
        }
        break;
      }
      case 'TopBandBtnClose': {
        this.getExpiryHoursAndCloseWidget(
          PRIMESCREEN_STORAGE_NAME[componentName].DISMISS,
          this._const.TOPBAND_DISMISS_EXPIRY_HOURS,
        );
        this.fireGA(data.ga_action, data.ga_label);
        break;
      }
      case 'ToastBtnClose': {
        this.getExpiryHoursAndCloseWidget(
          PRIMESCREEN_STORAGE_NAME[componentName],
          this._const.TOAST_TIP_EXPIRY_HOURS,
        );
        break;
      }
      case 'SubscribeNudgeClose': {
        this.unmountWidget(componentName);
        this.fireGA(data.ga_action, data.ga_label);
        break;
      }
      case 'AddFreeSessionLoyalUserClose': {
        this.unmountWidget(componentName);
        this.fireGA(data.ga_action, data.ga_label);
        window.location.reload(true);
        break;
      }
      case 'learnmore':
        this.learnmoreClickHandler(e, data);
        break;
      case 'firega':
        this.fireGA(data.ga_action, data.ga_label, data.nonInteraction);
        break;
      case 'cta_topband': {
        // close as well.
        this.getExpiryHoursAndCloseWidget(
          PRIMESCREEN_STORAGE_NAME[componentName].CTACLICK,
          this._const.TOPBAND_CTA_EXPIRY_HOURS,
        );
        this.ctaClickHandler(e, data);
        break;
      }
      case 'SubscribeNudge':
        primePaymentflowStartEmitter({
          formType: 'paymentScreen',
          utmsFinal: data.utms,
        });
        this.fireGA(data.ga_action, data.ga_label);
        break;
      case 'AddFreeSessionLoyalUsers': {
        primePaymentflowStartEmitter({
          formType: 'paymentScreen',
          stop_redirection_for_subscribed: true,
          utmsFinal: data.utms,
        });
        this.fireGA(data.ga_action, data.ga_label);
        break;
      }
      case 'planPage': {
        this.fireGA(data.ga_action, data.ga_label);
        // this.toiPlusSubscriptionHandler(e, 'planScreen');
        this.ctaClickHandler(e, data);
        break;
      }
      case 'toiplusSubscriptionPayment': {
        this.toiPlusSubscriptionHandler(e, 'paymentScreen');
        this.fireGA(data.ga_action, data.ga_label);
        break;
      }
      case 'toiplusSubscriptionPlan_topBand': {
        this.getExpiryHoursAndCloseWidget(
          PRIMESCREEN_STORAGE_NAME[componentName].CTACLICK,
          this._const.TOPBAND_CTA_EXPIRY_HOURS,
        );
        // this.toiPlusSubscriptionHandler(e,'planScreen');
        this.fireGA(data.ga_action, data.ga_label);
        break;
      }
      case 'fireGrx': {
        this.fireSubscribeGrx(data.ga_action, data.ga_label);
        break;
      }
      default:
        this.ctaClickHandler(e, data);
    }
  };

  getPrcValue = props => {
    const { userData } = props || this.props;
    let prcCookie = 0;
    if (
      typeof window !== 'undefined' &&
      window.location.href.indexOf('frmapp') > 0 &&
      (window.location.href.indexOf('pc=yes') > 0 ||
        window.location.href.indexOf('pc2=yes') > 0)
    ) {
      prcCookie = getPrcCookieValue();
      if (prcCookie === 0) {
        prcCookie = PRC_FOR_SUBSCRIBED;
      }
    }
    return userData && userData.prcValue ? userData.prcValue : prcCookie;
  };

  renderSwitch() {
    const { LoadedComponent, commonNudgesTranslations } = this.state;
    if (!commonNudgesTranslations || !commonNudgesTranslations.currencyCode) {
      return null;
    }
    const prc = this.getPrcValue();
    const {
      allActivity,
      theme,
      type,
      isWapView,
      componentName,
      msid,
      disableBlocker,
      force,
    } = this.props;

    const { defaultTimesPoints } = this.state.commonNudgesTranslations;
    //this.timesPoints = getUserTimesPointByPRC(allActivity, prc);
    this.timesPoints = getUserTimesPaidPoints(
      isWapView,
      allActivity,
      defaultTimesPoints,
    );
    let PropsToPass;

    switch (componentName) {
      case 'InlineWidget':
        if (
          (prc === PRC_FOR_FTU && this.showBlockerToFTU(prc)) ||
          prc !== PRC_FOR_FTU
        ) {
          PropsToPass = {
            prc,
            replaceTokens: this.replaceTokens,
            clickHandler: this.clickHandler,
            points: this.timesPoints,
            theme,
            type,
            isWapView,
            fcap: this.props.fcap || false,
            shortInlineWidgetTranslation:
              commonNudgesTranslations &&
              commonNudgesTranslations.inlineWidgetShort,
            longInlineWidgetTranslation:
              commonNudgesTranslations &&
              commonNudgesTranslations.inlineWidgetLong,
            useContentVisibilty: this.props.useContentVisibilty,
            isRHSWidgetAS: this.props.isRHSWidgetAS,
            userPrcData: this.props.userPrcData,
          };
        }
        break;
      case 'Toast':
        PropsToPass = {
          prc,
          clickHandler: this.clickHandler,
          isWapView,
        };
        break;
      case 'TopBand':
        if (prc === PRC_FOR_FTU || force) {
          PropsToPass = {
            prc,
            clickHandler: this.clickHandler,
            replaceTokens: this.replaceTokens,
            isWapView,
            points: this.timesPoints,
            daysLeft: this.getActiveDaysLeft(),
            theme,
            force,
            topBandTranslation:
              commonNudgesTranslations && commonNudgesTranslations.topBand,
          };
        }
        break;
      case 'SubscribeNudge':
        PropsToPass = {
          prc,
          clickHandler: this.clickHandler,
          isWapView,
          points: this.timesPoints,
          isLogin: this.props.userData && this.props.userData.isLoggedIn,
          getStorage: this.getStorage,
          setInLocalStorage: this.setInLocalStorage,
          msid,
          force,
          theme,
          disableBlocker,
          subscribeNudgeTranslation:
            commonNudgesTranslations && commonNudgesTranslations.subscribeNudge,
        };
        break;
      case 'AddFreeSessionLoyalUsers':
        PropsToPass = {
          prc: this.props.userData && this.props.userData.isLoggedIn ? prc : -1,
          clickHandler: this.clickHandler,
          isWapView,
          points: this.timesPoints,
          isLogin: this.props.userData && this.props.userData.isLoggedIn,
          getStorage: this.getStorage,
          removeStorage: this.removeStorage,
          setInLocalStorage: this.setInLocalStorage,
          disableBlocker,
          theme,
          force,
        };

        break;
      case 'HPPrimeInlineWidget':
        PropsToPass = {
          prc: this.props.userData && this.props.userData.isLoggedIn ? prc : -1,
          clickHandler: this.clickHandler,
          isWapView,
          hpPrimeInlineWidgetTranslation:
            commonNudgesTranslations &&
            commonNudgesTranslations.inlineWidgetNewHP,
          toiHpWidget:
            commonNudgesTranslations && commonNudgesTranslations.TOIHPWidget,
          userPrcData: this.props.userPrcData,
        };

        break;
      case 'BottomToast':
        if (!this.props.showToiPlusCongratspopup) break;
        PropsToPass = {
          prc: this.props.userData && this.props.userData.isLoggedIn ? prc : -1,
          getStorage: this.getStorage,
          removeStorage: this.removeStorage,
          setInLocalStorage: this.setInLocalStorage,
          userData: this.props.userData,
        };
        break;
      case 'ToiplusSubscribeInlineWidget':
        PropsToPass = {
          prcValue:
            this.props.userData && this.props.userData.isLoggedIn ? prc : -1,
          clickHandler: this.clickHandler,
          isWapView,
          indiaHPTopNudge:
            commonNudgesTranslations &&
            commonNudgesTranslations.indiaHPTopNudge,
          currencyCode: commonNudgesTranslations.currencyCode,
        };
        break;
      default:
        return null;
    }

    if (PropsToPass) {
      return <LoadedComponent {...PropsToPass} />;
    }
    return null;
  }

  render() {
    const { componentName } = this.props;
    if (!this.state.hasMounted) {
      return null;
    }
    // mount component;
    if (
      (!this.state.mounted[componentName] || !this.state.LoadedComponent) &&
      componentName === 'InlineWidget'
    ) {
      return <div className="primeScreenWidgetWrapper CLSPlaceholder" />;
    }
    if (!this.state.mounted[componentName] || !this.state.LoadedComponent) {
      return null;
    }

    if (!this.props.showToiPlusNudges && componentName !== 'BottomToast') {
      if (
        !(
          (componentName === 'TopBand' && this.getPrcValue() === PRC_FOR_FTU) ||
          (componentName === 'HPPrimeInlineWidget' &&
            (this.getPrcValue() === PRC_FOR_FTU ||
              this.getPrcValue() === PRC_FOR_SUBSCRIBED))
        )
      ) {
        return null;
      }
    }
    if (
      componentName !== 'HPPrimeInlineWidget' &&
      componentName !== 'InlineWidget'
    ) {
      return null;
    }
    return (
      <ErrorBoundary>
        <Suspense fallback={<div />}>{this.renderSwitch()}</Suspense>
      </ErrorBoundary>
    );
  }
}

PrimeScreen.propTypes = {
  isWapView: PropTypes.bool,
  translationData: PropTypes.shape({}),
  componentName: PropTypes.string,
  theme: PropTypes.string,
  type: PropTypes.string,
  allActivity: PropTypes.arrayOf(PropTypes.shape({})),
  userData: PropTypes.shape({
    isLoggedIn: PropTypes.bool,
    prcValue: PropTypes.number,
  }),
  msid: PropTypes.string,
  disableBlocker: PropTypes.bool,
  force: PropTypes.bool,

  isPrime: PropTypes.bool,
  showToiPlusCongratspopup: PropTypes.bool,

  useContentVisibilty: PropTypes.bool,
  showToiPlusNudges: PropTypes.bool,
  isRHSWidgetAS: PropTypes.bool,
};

PrimeScreen.defaultProps = {
  allActivity: [],
  isWapView: false,
  theme: undefined,
  componentName: 'InlineWidget',
  type: undefined,
  userData: {},
  msid: undefined,
  force: false,
  disableBlocker: undefined,
  isPrime: false,
  translationData: {},
  showToiPlusCongratspopup: false,

  useContentVisibilty: false,
  showToiPlusNudges: false,
  isRHSWidgetAS: false,
};

const mapStateToProps = state => ({
  isPrime: state.isPrime,
  translationData: _get(state, 'translationConfig.data', {}),
  userData: state.login && state.login.userData ? state.login.userData : {},
  allActivity: state.timespointmodal && state.timespointmodal.allActivity,
  showToiPlusCongratspopup:
    typeof state.toiplusconfig !== 'undefined' &&
    state.toiplusconfig?.showToiPlusCongratspopup,
  showToiPlusNudges:
    typeof state.toiplusconfig !== 'undefined' &&
    state.toiplusconfig?.showToiPlusNudges,
  userPrcData: state.login.userPrcData,
});

export default connect(mapStateToProps, null)(PrimeScreen);
